import dashboard from "@/router/dashboard";

const routes = [
    ...dashboard,
    {
        path: '/',
        name: 'index',
        component: () => import('@/pages/Index/IndexPage.vue'),
        meta: {
            requiresAuth: false,
            layout: 'navbar',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/pages/Index/LoginPage.vue'),
        meta: {
            requiresAuth: false,
            layout: 'base',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/courses',
        name: 'courses',
        component: () => import('@/pages/Index/CoursesPage.vue'),
        meta: {
            requiresAuth: false,
            layout: 'navbar',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/courses/:id/show',
        name: 'courses.show',
        component: () => import('@/pages/Index/CourseShow.vue'),
        meta: {
            requiresAuth: false,
            layout: 'navbar',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/reels/:id',
        name: 'reels.show',
        component: () => import('@/pages/Index/ReelShow.vue'),
        meta: {
            requiresAuth: false,
            layout: 'navbar',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/posts',
        name: 'posts',
        component: () => import('@/pages/Index/PostIndex.vue'),
        meta: {
            requiresAuth: false,
            layout: 'navbar',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/posts/:id/show',
        name: 'posts.show',
        component: () => import('@/pages/Index/PostShow.vue'),
        meta: {
            requiresAuth: false,
            layout: 'navbar',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import('@/pages/Index/ContactPage.vue'),
        meta: {
            requiresAuth: false,
            layout: 'navbar',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/certificate',
        name: 'certificate',
        component: () => import('@/pages/Index/CertificatePage.vue'),
        meta: {
            requiresAuth: false,
            layout: 'navbar',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
    {
        path: '/one-id/impersonate',
        name: 'impersonate',
        component: () => import('@/pages/Index/ImpersonatePage.vue'),
        meta: {
            requiresAuth: false,
            layout: 'navbar',
            title: 'SKILLS | MIGRATSIYA AGENTLIGI',
        }
    },
]

export default routes